module.exports = __webpack_public_path__ + "0.2.26/img/icon_sousuo.80c210a2.png";